import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Spin } from "antd";
import { observer } from "mobx-react";
import { useEffect } from "react";
import { Outlet } from "react-router-dom";
import { useStores } from "../../../../store/stores.js";
import { ConfigHintModal } from "../../hintModal.js";
const TcfLayout = observer(()=>{
    const { tcfStore } = useStores();
    const { purposes } = tcfStore;
    // Load all declarations
    useEffect(()=>{
        tcfStore.fetchDeclarations();
    }, []);
    return purposes.size === 0 ? /*#__PURE__*/ _jsx(Spin, {
        style: {
            margin: "auto",
            marginTop: 15
        }
    }) : /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Outlet, {}),
            /*#__PURE__*/ _jsx(ConfigHintModal, {
                identifier: "tcf-vendor"
            })
        ]
    });
});
export { TcfLayout };
